import { selectors as selectorsV2 } from 'stores/organizations';

export const types = {
  AGGREGATE_METADATA_REQUEST: 'ORGANIZATION_DATA/AGGREGATE_METADATA_REQUEST',
  AGGREGATE_METADATA_SUCCESS: 'ORGANIZATION_DATA/AGGREGATE_METADATA_SUCCESS',
  AGGREGATE_METADATA_FAILURE: 'ORGANIZATION_DATA/AGGREGATE_METADATA_FAILURE',
  ORGANIZATION_PULL_REQUEST_AUTHORS_REQUEST:
    'ORGANIZATION_PULL_REQUEST_AUTHORS_REQUEST',
  ORGANIZATION_PULL_REQUEST_AUTHORS_SUCCESS:
    'ORGANIZATION_PULL_REQUEST_AUTHORS_SUCCESS',
  ORGANIZATION_PULL_REQUEST_AUTHORS_FAILURE:
    'ORGANIZATION_PULL_REQUEST_AUTHORS_FAILURE',
};

export const initialState = {
  error: null,
  aggregateMetadata: {},
  pullRequestAuthors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.AGGREGATE_METADATA_REQUEST: {
      const { organizationUUID } = action;
      return {
        ...state,
        error: null,
        aggregateMetadata: {
          ...state.aggregateMetadata,
          [organizationUUID]: {
            ...state.aggregateMetadata[organizationUUID],
            isLoading: true,
          },
        },
      };
    }
    case types.AGGREGATE_METADATA_SUCCESS: {
      const { organizationUUID, data } = action;
      return {
        ...state,
        aggregateMetadata: {
          ...state.aggregateMetadata,
          [organizationUUID]: data,
          isLoading: false,
        },
      };
    }
    case types.AGGREGATE_METADATA_FAILURE: {
      const { organizationUUID } = action;
      return {
        ...state,
        error: action.error,
        aggregateMetadata: {
          ...state.aggregateMetadata,
          [organizationUUID]: {
            ...state.aggregateMetadata[organizationUUID],
            isLoading: false,
          },
        },
      };
    }
    case types.ORGANIZATION_PULL_REQUEST_AUTHORS_REQUEST: {
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          isLoading: true,
          error: null,
        },
      };
    }
    case types.ORGANIZATION_PULL_REQUEST_AUTHORS_SUCCESS: {
      const { organizationUUID, data } = action;
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          [organizationUUID]: data,
          isLoading: false,
          error: null,
        },
      };
    }
    case types.ORGANIZATION_PULL_REQUEST_AUTHORS_FAILURE: {
      const { organizationUUID, error } = action;
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          [organizationUUID]: {
            ...state.pullRequestAuthors[organizationUUID],
            isLoading: false,
            error,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const actions = {
  fetchAggregateMetadata: (organizationUUID) => ({
    type: types.AGGREGATE_METADATA_REQUEST,
    organizationUUID,
  }),
  fetchOrganizationPullRequestAuthors: (organizationUUID, inputValue) => ({
    type: types.ORGANIZATION_PULL_REQUEST_AUTHORS_REQUEST,
    organizationUUID,
    inputValue,
  }),
};

export const selectors = {
  activePullRequests: (state, organizationUUID) =>
    selectorsV2.pullRequests.active(state, organizationUUID),
  activeNextPageUrl: (state, organizationUUID) =>
    selectorsV2.pullRequests.activeNextPage(state, organizationUUID),
  activeIsLoading: (state, organizationUUID) =>
    selectorsV2.pullRequests.activeIsLoading(state),
  activeIsLoadingMore: (state, organizationUUID) =>
    selectorsV2.pullRequests.activeIsLoadingMore(state),

  inactivePullRequests: (state, organizationUUID) =>
    selectorsV2.pullRequests.inactive(state, organizationUUID),
  inactiveNextPageUrl: (state, organizationUUID) =>
    selectorsV2.pullRequests.inactiveNextPage(state, organizationUUID),
  inactiveIsLoading: (state, organizationUUID) =>
    selectorsV2.pullRequests.inactiveIsLoading(state),
  inactiveIsLoadingMore: (state, organizationUUID) =>
    selectorsV2.pullRequests.inactiveIsLoadingMore(state),

  aggregateMetadata: (state, organizationUUID) =>
    state.organizationData.aggregateMetadata[organizationUUID],
  pullRequestAuthors: (state, organizationUUID) =>
    state.organizationData.pullRequestAuthors[organizationUUID],
};
